import { AutoAwesome } from "@mui/icons-material";
import { ChatUI } from "../Chat/Chat";
import { ShineBorder } from "../ShineBorder/ShineBorder";

type RightColumnProps = {
  defaultSize?: number;
  minSize?: number;
  onClose?: () => void;
};

export const RightColumn = ({ onClose }: RightColumnProps) => {
  return (
    <div className="h-full w-full">
      <ChatUI onClose={onClose} />
    </div>
  );
};

type RightColumnToggleProps = {
  onClick: () => void;
};

export const RightColumnToggle = ({ onClick }: RightColumnToggleProps) => {
  return (
    <button
      onClick={onClick}
      className="fixed cursor-pointer right-0 top-16 -translate-y-1/2 rounded-l-md bg-white p-2 shadow-md border-[1px] border-solid border-gray-400 overflow-hidden group"
    >
      <ShineBorder
        borderWidth={1}
        duration={4}
        className="opacity-0 group-hover:opacity-100 transition-opacity"
      />
      <div className="relative top-2/3 z-10">
        <AutoAwesome className="size-5 [&>path]:fill-none [&>path]:stroke-gray-400 group-hover:[&>path]:stroke-[url(#gradient)] stroke-1 transition-colors" />
        <svg width="0" height="0">
          <defs>
            <linearGradient id="gradient" x1="0%" y1="0%" x2="100%" y2="0%">
              <stop offset="0%" stopColor="#A07CFE" />
              <stop offset="50%" stopColor="#FE8FB5" />
              <stop offset="100%" stopColor="#FFBE7B" />
            </linearGradient>
          </defs>
        </svg>
      </div>
    </button>
  );
};
